(function($) {

	'use strict';

	var init = function() {

        activateVideo();
    };
    
    var activateVideo = function() {
        $('.flex-video__overlay').each(function(index){
            $('.flex-video__overlay:eq('+ index +')').on('click', function() {
                $('.flex-video__overlay:eq('+ index +')').addClass('flex-video__overlay--none');
                $('.flex-video__video video').get(index).play();
                $('.flex-video__video video').get(index).controls = true;
            })
        })
    }

	$(document).ready(function() {
		init();
	});

})(jQuery);
